<template>
<el-container>
</el-container>
</template>

<script>
import { doVerifyUser } from '@/request/user.js'
export default {
  name: 'verifyUser',
  components: {
  },
  data () {
    return {
      source: 'roompai',
      conver: ''
    }
  },
  mounted () {
    var source = this.common.linkQuerys.source
    if (source !== '' && source !== undefined && source !== null) {
      this.source = source
    } else {
      var sourceExpires = localStorage.getItem('sourceExpiresAt')
      if (sourceExpires !== '' && sourceExpires !== undefined && sourceExpires !== null) {
        var nowTime = Date.now()
        if (nowTime <= sourceExpires) {
          source = localStorage.getItem('source')
          this.source = source
        }
      }
    }
    let conver = this.common.linkQuerys.conver
    if (conver === 1 || conver === '1') {
      this.conver = conver
    }
    var time = parseInt(new Date().getTime() / 1000)
    var email = this.common.linkQuerys.userName
    var key = this.common.linkQuerys.key
    var dataJson = {'email': email, 'key': key, 'time': time}
    var data = this.common.encryptionData(dataJson, this)
    doVerifyUser(data).then(res => {
      // this.$router.push({name: 'login', query: {'source': this.source}})
      var newQuerys = this.common.linkEncode({'source': this.source}, 'obj')
      if (this.conver === 1 || this.conver === '1') {
        newQuerys = this.common.linkEncode({'source': this.source, 'conver': this.conver}, 'obj')
      }
      this.$router.push({name: 'login', params: {'querys': newQuerys}})
      // if (res.flag === '200') {
      //   this.$router.push({name: 'login'})
      // } else {
      //   this.$router.push({name: 'login', query: {'verify': 1}})
      // }
    })
  },
  methods: {

  }
}
</script>

<style scoped>
.main{height:600px;background-color:rgba(242, 242, 242, 1);color: rgba(0, 0, 0, 0.6470588235294118);}
img{height:70px;width:80px;}
.clause-content span{ font-weight: 400;font-size: 14px;line-height: 22px; display:block; margin-bottom:20px;}
@media screen and (min-width: 1001px) {
.clause-main{width:70%;}
}
@media screen and (max-width: 1000px) {
.clause-main{width:90%;}
}
</style>



// WEBPACK FOOTER //
// src/components/account/verifyUser.vue